// src/auth/FullPageLoader.jsx
//
// A calm, on-brand full-page loading state (authguard-consent-gate slice).
// Replaces AuthGuard's blank `return null` while auth resolves, and is reused
// while the consent access-gate checks for a valid consent record. Dark-academia
// book-* theme + Cinzel/Cormorant, matching the app shell.
import React from 'react';

export default function FullPageLoader({ label = 'Loading' }) {
    return (
        <div className="min-h-screen bg-book-bg paper-texture flex items-center justify-center px-4">
            <div className="flex flex-col items-center gap-4 text-book-accent">
                <span className="inline-block w-8 h-8 border-2 border-book-accent/30 border-t-book-accent rounded-full animate-spin" aria-hidden="true" />
                <span className="font-display text-xs font-semibold text-book-muted" role="status">{label}</span>
            </div>
        </div>
    );
}
